
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class YardimTuruSearchAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "YardimTuruListe/GetMahalleListe";
        super(baseUrl);
    }


    yardimTuruSearch(request: YardimTuruSearchRequest) {

        return this.post("", request);

    }

}
export default new YardimTuruSearchAPI();

class YardimTuruSearchRequest {
    yardimTuruKodu?: number;

    constructor(
        yardimTuruKodu?: number,
    ) {
        this.yardimTuruKodu = yardimTuruKodu;
    }
}
export { YardimTuruSearchRequest };